import React from 'react';

class FHLayout extends React.Component {
    constructor() {
        super();   
    }

    componentWillMount() {
        require('./FHLayout.styl');
    }
}

class FHLayoutBase extends FHLayout {
    render() {
        return (
            <div className="FHLayout">
                {this.props.children}
            </div>
        );
    }
}

class FHLayoutRow extends FHLayout {
    render() {
        return (
            <div className="FHLayout__row">
                <div className="FHLayout__box">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

class FHLayoutBody extends FHLayout {
    render() {
        return (
            <div className="FHLayout__row FHLayout__row--maxed">
                <div className="FHLayout__box">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export {
    FHLayoutBase,
    FHLayoutRow,
    FHLayoutBody
};
  


// WEBPACK FOOTER //
// ./src/components/FHLayout/index.js